import { changeRoute } from "@/router";
import { usePiniaStore } from "@/stores/store";

export const checkIfArrayElementsMatch = (
    existingRoles: string[],
    storedRoles: any,
) => {
    return existingRoles.some((r) => storedRoles.indexOf(r) >= 0);
};

export const redirectToOriginOrSchoolOverview = (origin: any) => {
    // For school users, if an origin is provided we will redirect to it
    // when they are logged in. This is to enable the email download link
    // to work
    const pStore = usePiniaStore();

    if (pStore.areContractsSigned) {
        if (origin) {
            changeRoute(origin);
        } else {
            changeRoute("/school/overview");
        }
    } else {
        changeRoute("/school/compliance/contracts");
    }
};

/**
 * Sanitises the origin parameter to ensure it is a valid relative URL path. This is used to prevent open redirect vulnerabilities.
 * The function performs the following checks:
 * 1. Verifies that the input is a string and trims any whitespace.
 * 2. Attempts to decode the string using decodeURIComponent, but falls back to the original string if decoding fails.
 * 3. Checks if the decoded string contains a URL scheme (e.g., "http://") or starts with "//", which would indicate an absolute URL.
 * If so, it returns undefined.
 * 4. Ensures that the decoded string starts with "/", indicating it's a relative path. If not, it returns undefined.
 * 5. If all checks pass, it returns the sanitised relative path.
 * @param {unknown} value
 * @returns {string | undefined}
 */
export const sanitiseOriginParam = (value: unknown): string | undefined => {
    if (typeof value !== "string") return undefined;
    const trimmed = value.trim();

    let decoded = trimmed;
    try {
        decoded = decodeURIComponent(trimmed);
    } catch {}

    const lower = decoded.toLowerCase();
    const hasScheme = /^[a-z][a-z0-9+.-]*:/.test(lower);
    if (hasScheme || lower.startsWith("//")) return undefined;

    if (!decoded.startsWith("/")) return undefined;
    return decoded;
};
